import React, { useEffect, useRef, useState } from "react";
import { img_placehlder } from "../../../../assets";
import { BsFillSendFill, BsThreeDots } from "react-icons/bs";
import { GoChevronRight } from "react-icons/go";
import { groupMemberListApi } from "../../../../services/groupMember";
import { toastMessage } from "../../../../utils/toastMessage";
import MemberListModal from "./MemberListModal";
import { useSelector } from "react-redux";
import { socket } from "../../../../utils/socket";
import { TextArea } from "../../../../Components/header/form";
import { IoImage } from "react-icons/io5";
import FileUpload from "./FileUpload";
import { GiHamburgerMenu } from "react-icons/gi";
import { uploadAttachmentApi } from "../../../../services/message";
import ViewProfile from "./ViewProfile";
import RightSideMessage from "../groupMessages/RightSideMessage";
import LeftSideMessage from "../groupMessages/LeftSideMessage";
import { CiCircleRemove } from "react-icons/ci";
import { previewFiles } from "../groupMessages/commonMessage";

const GroupChat = ({
  chatMessage,
  setChatMessage,
  chatContainerRef,
  fetchMessages,
  selectedChat,
  currentPage,
  setCurrentPage,
  totalPages,
  showChatUsers,
  chatId,
  groupDetails,

  isReplay,
  setIsReplay,
  selectedReplyData,
  setSelectReplyData,
}) => {
  const chatEndRef = useRef(null);
  const chatInputRef = useRef(null);
  const replyRef = useRef(null);
  const messageRefs = useRef({});
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [inputData, setInputData] = useState({ message: "", type: "" });
  const [memberList, setMemberList] = useState([]);
  const [memberListModal, setMemberListModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [page, setPage] = useState(1);
  const [attachment, setAttachment] = useState({
    attachment: "",
    type: "",
    url: "",
  });

  const [file, setFile] = useState({ attachment: "" });
  const [imageModal, setImageModal] = useState(false);
  const [imageButtonLoader, setImageButtonLoader] = useState(false);
  const [viewProfileUrl, setViewProfileUrl] = useState("");
  const [viewProfileModal, setViewProfileModal] = useState(false);
  const [highlightMsg, setHighlightMsg] = useState(false);
  //-----------handle-Is-Reply-----------------
  const handleIsReply = () => {
    setIsReplay(false);
    setSelectReplyData({});
  };
  //----------handle-view-profile-------------
  const handleViewProfile = (image) => {
    if (image) {
      setViewProfileUrl(image);
      setViewProfileModal(true);
    }
  };
  // Member List
  const fetchGroupMemberList = async () => {
    try {
      const { data } = await groupMemberListApi({
        _id: selectedChat?._group?._id,
      });
      const { success, message, data: response, meta } = data;

      if (success) {
        setMemberList(response);
        setTotal(meta?.totalRecords);
      } else {
        toastMessage(message, "error", "fetchGroupMemberList");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  useEffect(() => {
    if (selectedChat?._group?._id) {
      fetchGroupMemberList();
    }
  }, [selectedChat?._group?._id]);

  //---------send-message---------------
  const sendDataHandler = (attachment) => {
    // console.log("attachment in group", attachment);
    let sendData = {};
    const uploadedUrl = attachment?.attachment || '';
    const fileExtension = uploadedUrl.split('.').pop().toLowerCase();

    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
    const isPDF = fileExtension === 'pdf';

    const hasMessage = inputData?.message?.trim();
    const hasAttachment = attachment?.attachment;

    // CASE 1: Text + Attachment
    if (hasMessage && hasAttachment) {
      sendData = {
        attachments: [{
          type: isImage ? "IMAGE" : isPDF ? "DOCUMENTS" : "UNKNOWN",
          url: attachment.attachment
        }],
        message: hasMessage,
        type: "BOTH"
      };
    }
    // CASE 2: Only Attachment (Image or PDF)
    else if (!hasMessage && hasAttachment) {
      sendData = {
        attachments: [{
          type: isImage ? "IMAGE" : isPDF ? "DOCUMENTS" : "UNKNOWN",
          url: attachment.attachment
        }],
        type: attachment.type || "MEDIA"
      };
    }
    // CASE 3: Only Text
    else if (hasMessage && !hasAttachment) {
      sendData = {
        message: hasMessage,
        type: inputData.type || "TEXT"
      };
    }
    if (Object.keys(sendData).length === 0) {
      toastMessage("No data to send.", "error", "sendData");
      return;
    }
    socket.emit("SENT_MESSAGE", {
      _chat: chatId || selectedChat?._id,
      ...(isReplay ? { replyOf: selectedReplyData?._id } : {}), // Conditionally add replyOf
      ...sendData,
    });
    setInputData({ message: "", type: "" });
    setAttachment({ attachment: "", type: "", url: "" });
    setFile({ attachment: "" });
    setIsReplay(false);
    setSelectReplyData({});
  };

  const receiveMessage = (data) => {
    const { success, data: response } = data;
    if (success) {
      setChatMessage((prev) => [...prev, response]);
    }
  };

  // Receive Chat List
  useEffect(() => {
    socket.on("RECEIVE_MESSAGE", receiveMessage);

    return () => {
      socket.off("RECEIVE_MESSAGE", receiveMessage);
    };
  }, []);

  const onEnterPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (attachment?.attachment) {
        sendDataHandler(attachment);
      } else if (inputData?.message.trim()) {
        sendDataHandler(inputData.message);
        setInputData({ ...inputData, message: "" });
      }
    } else if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
      setInputData({
        ...inputData,
        message: inputData?.message + "\n",
      });
    }
  };

  //   Load More older message
  const loadMoreMessages = () => {
    const chatContainer = chatContainerRef.current;
    if (chatContainer.scrollTop === 0 && totalPages > currentPage) {
      fetchMessages(currentPage + 1);
      setCurrentPage((prev) => prev + 1);
    }
  };
  // Scroll to the bottom whenever chatMessage changes (new messages)
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessage]);

  //----------image-past-handler-----------------
  const handlePaste = (event) => {
    const clipboardItems = event.clipboardData.items;
    for (let item of clipboardItems) {
      if (item.type.startsWith("image/")) {
        const file = item.getAsFile();
        setFile({ attachment: file });

        // Automatically upload the pasted image
        uploadAttachment(event, file);
        break;
      }
    }
  };
  //-----------image-create-url---------------
  const uploadAttachment = async (e, pastedFile) => {
    // console.log("pastedFile", pastedFile);
    if (!pastedFile) {
      return toastMessage("Please upload an image", "error", "selectMedia");
    }
    try {
      setImageButtonLoader(true);
      const formData = new FormData();
      formData.append("attachments", pastedFile);

      const { data } = await uploadAttachmentApi(formData);
      const { success, message, data: res } = data;

      if (success) {
        setAttachment({
          attachment: res?.[0]?.key,
          url: res?.[0]?.url,
          type: "MEDIA",
        });
        setInputData({ message: "", type: "" });
        // sendDataHandler({
        //   attachment: res?.[0]?.key,
        //   url: res?.[0]?.url,
        //   type: "MEDIA"
        // })
      }
      toastMessage(message, success ? "success" : "error", "addGroupHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setImageButtonLoader(false);
    }
  };

  useEffect(() => {
    document.addEventListener("paste", handlePaste);
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, []);
  //---------scroll-reply-message-----------------------
  const scrollToMessage = (messageId) => {
    if (messageRefs.current[messageId]) {
      // Scroll to the message
      messageRefs.current[messageId].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // Highlight the message
      const messageElement = messageRefs.current[messageId];
      messageElement.classList.add("highlight-message");
      // setHighlightMsg(true)
      // Remove the highlight after 2 seconds
      setTimeout(() => {
        messageElement.classList.remove("highlight-message");
        // setHighlightMsg(false)
      }, 2000);
    }
  };
  // // Check if attachment exists and focus on the chat input div
  useEffect(() => {
    if (attachment?.attachment && chatInputRef.current) {
      chatInputRef.current.focus();
    } else if (selectedReplyData?._id && chatInputRef.current) {
      replyRef.current.focus();
    }
  }, [attachment?.attachment, selectedReplyData?._id]);

  return (
    <div className="chatting ">
      {/* -------chatMessage.length > 0 ?---this condition-work-if-chatMessage-empty-then-show-no-data-found------ */}
      {/* {chatMessage && chatMessage.length > 0 ? ( */}
      <>
        <div className="chat_wrapper">
          <div className="chat-header">
            <div className="responsive_menubar" onClick={showChatUsers}>
              <button>
                <GiHamburgerMenu />
              </button>
            </div>
            <div
              className="avatar"
              onClick={() =>
                handleViewProfile(selectedChat?._group?.coverImage)
              }
            >
              <img src={selectedChat?._group?.coverImage || img_placehlder} />
            </div>
            <div className="text-content">
              <div className="title">{selectedChat?._group?.name}</div>
              <div
                className="memberss"
                onClick={() => setMemberListModal(true)}
              >
                {selectedChat?._group?.name && (
                  <>
                    {total > 10 ? "10+ Members" : `${total} Members`}
                    <GoChevronRight className="memberss_arrow" />
                  </>
                )}
              </div>
            </div>
          </div>

          <div
            className="chat-messages"
            ref={chatContainerRef}
            onScroll={loadMoreMessages}
          >
            {chatMessage &&
              chatMessage
                .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)) // Sort the messages by date
                .map((data, ind) => {
                  return (
                    <div
                      key={data._id}
                      ref={(el) => {
                        if (el) messageRefs.current[data._id] = el;
                      }}
                    >
                      {data?._sender?._id === showAuth?._id ? (
                        <RightSideMessage
                          {...{
                            data,
                            ind,
                            handleViewProfile,
                            scrollToMessage,
                            highlightMsg,
                            setIsReplay,
                            setSelectReplyData,
                          }}
                        />
                      ) : (
                        <LeftSideMessage
                          {...{
                            data,
                            handleViewProfile,
                            setIsReplay,
                            setSelectReplyData,
                            scrollToMessage,
                            highlightMsg,
                          }}
                        />
                      )}
                    </div>
                  );
                })}
            <div ref={chatEndRef} />
          </div>
        </div>
        {/* --------send-message--input--------------- */}
        <div className="isReply img_reply">
          {isReplay && (
            <>
              <button type="button" className="remove" onClick={handleIsReply}>
                <CiCircleRemove />
              </button>
              <div className="reply_text">
                <b className="user_name">
                  {selectedReplyData?._sender?.fullName}
                </b>

                {selectedReplyData?.message && (
                  <p>{selectedReplyData?.message}</p>
                )}
                {selectedReplyData?.attachments.length > 0 && (
                  previewFiles(selectedReplyData?.attachments?.[0]?.url)
                )}
              </div>
            </>
          )}
          {attachment?.url && (
            <div className="reply_text post_img">
              {previewFiles(attachment?.url)}
            </div>
          )}
        </div>

        <div
          className="chat-input"
          tabIndex={0}
          onKeyDown={onEnterPress}
          ref={chatInputRef}
        >
          <TextArea
            type="text"
            ref={replyRef}
            // disabled={attachment?.attachment}
            className="input-field"
            value={inputData?.message || ""}
            placeholder={attachment?.url ? 'Add Caption...' : 'Write message here...'}
            name="message"
            onChange={(e) =>
              setInputData({
                ...inputData,
                message: e.target.value,
                type: "TEXT",
              })
            }
          // onKeyDown={onEnterPress}
          />
          <IoImage
            className="input_inside_img"
            onClick={() => setImageModal(true)}
          />
          <button
            className="send-button"
            disabled={
              (!inputData?.message && !attachment?.attachment) ||
              imageButtonLoader
            }
            onClick={() => sendDataHandler(attachment)}
          >
            <BsFillSendFill />
          </button>
        </div>
      </>

      {/* Member List Modal  */}
      <MemberListModal
        memberList={memberList}
        total={total}
        setPage={setPage}
        show={memberListModal}
        handleClose={() => setMemberListModal(false)}
      />

      {/* -------image-upload-------------- */}
      <FileUpload
        show={imageModal}
        close={() => setImageModal(false)}
        attachment={attachment}
        setAttachment={setAttachment}
        file={file}
        setFile={setFile}
        sendDataHandler={sendDataHandler}
      />

      {/* -------view-profile-image-------------- */}
      <ViewProfile
        show={viewProfileModal}
        close={() => setViewProfileModal(false)}
        profileUrl={viewProfileUrl}
      />
    </div>
  );
};

export default GroupChat;
